"use strict";
exports.__esModule = true;
exports.Drawer360 = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_1 = tslib_1.__importStar(require("react"));
var Dialog_1 = require("../Dialog");
var Icon_1 = require("../Icon");
var IconButton_1 = require("../IconButton");
var Tooltip_1 = require("../Tooltip");
var Typography_1 = require("../Typography");
var ActionFooter_1 = require("./ActionFooter");
var DiscardDialog_1 = require("./DiscardDialog");
var helpers_1 = require("./helpers");
var customSizes = [
    { 'one-third': '560px', 'two-thirds': '720px', 'max-width': '850px' },
    { 'one-third': '33vw', 'two-thirds': '66vw', 'max-width': '90vw' }
];
var useStyles = styles_1.makeStyles(function () { return ({
    sideDrawerRoot: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: '464px',
        width: function (_a) {
            var _b = _a.responsive, responsive = _b === void 0 ? true : _b, _c = _a.size, size = _c === void 0 ? 'two-thirds' : _c;
            return customSizes[Number(responsive)][size];
        }
    },
    topBar: {
        padding: '1rem 1.5rem',
        paddingRight: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: 'inset 0px -1px 0px #c1c7d0;'
    },
    title: {
        fontSize: 20,
        fontWeight: 600
    },
    dialogContent: {
        position: 'relative'
    },
    body: {
        padding: '1.5rem',
        position: 'absolute',
        inset: 0,
        background: '#EDF2F7',
        overflowY: 'scroll'
    }
}); });
function Drawer360(_a) {
    var _b = _a.anchor, anchor = _b === void 0 ? 'right' : _b, children = _a.children, onClose = _a.onClose, onSave = _a.onSave, onDiscard = _a.onDiscard, _c = _a.responsive, responsive = _c === void 0 ? true : _c, _d = _a.size, size = _d === void 0 ? 'two-thirds' : _d, _e = _a.showActionButtons, showActionButtons = _e === void 0 ? true : _e, title = _a.title, unsavedChanges = _a.unsavedChanges, open = _a.open, disableSaveButton = _a.disableSaveButton, isLoading = _a.isLoading, localesProp = _a.locales, 
    // prop sanitisation for deprecated props
    onBackdropClick = _a.onBackdropClick, onEscapeKeyDown = _a.onEscapeKeyDown, onRendered = _a.onRendered, rest = tslib_1.__rest(_a, ["anchor", "children", "onClose", "onSave", "onDiscard", "responsive", "size", "showActionButtons", "title", "unsavedChanges", "open", "disableSaveButton", "isLoading", "locales", "onBackdropClick", "onEscapeKeyDown", "onRendered"]);
    var classes = useStyles({ responsive: responsive, size: size });
    var _f = react_1["default"].useState(false), showDiscardDialog = _f[0], setShowDiscardDialog = _f[1];
    var handleClose = react_1.useCallback(function (e, reason) {
        if (isLoading) {
            return;
        }
        if (showActionButtons && unsavedChanges) {
            setShowDiscardDialog(true);
        }
        else {
            onClose && onClose(e, reason !== null && reason !== void 0 ? reason : 'backdropClick');
        }
    }, [showActionButtons, unsavedChanges, onClose, isLoading]);
    var handleSave = react_1.useCallback(function (e) {
        onSave && onSave(e);
    }, [onSave]);
    var handleDiscard = react_1.useCallback(function (e) {
        setShowDiscardDialog(false);
        onDiscard && onDiscard(e);
    }, [onDiscard]);
    var closeDiscardDialog = react_1.useCallback(function () {
        setShowDiscardDialog(false);
    }, []);
    var locales = helpers_1.useLocales(localesProp);
    return (react_1["default"].createElement(core_1.Drawer, tslib_1.__assign({}, rest, { anchor: anchor, elevation: 2, onClose: handleClose, open: open }),
        react_1["default"].createElement("div", { className: classes.sideDrawerRoot + " " + rest.className },
            react_1["default"].createElement("div", { className: classes.topBar },
                react_1["default"].createElement(Typography_1.H3, { className: classes.title }, title),
                !isLoading && (react_1["default"].createElement(Tooltip_1.Tooltip, { title: locales.closeButtonLabel },
                    react_1["default"].createElement("div", null,
                        react_1["default"].createElement(IconButton_1.IconButton, { onClick: handleClose },
                            react_1["default"].createElement(Icon_1.EIcon, { color: "secondary", name: "x" })))))),
            react_1["default"].createElement(Dialog_1.DialogContent, { className: classes.dialogContent },
                react_1["default"].createElement("div", { className: classes.body }, children)),
            showActionButtons && (react_1["default"].createElement(ActionFooter_1.ActionFooter, { disableSaveButton: disableSaveButton, handleClose: handleClose, handleSave: handleSave, isLoading: isLoading, locales: locales, showDiscard: Boolean(onDiscard), unsavedChanges: unsavedChanges }))),
        react_1["default"].createElement(DiscardDialog_1.DiscardDialog, { handleDiscard: handleDiscard, locales: locales, onClose: closeDiscardDialog, open: showDiscardDialog })));
}
exports.Drawer360 = Drawer360;
//# sourceMappingURL=Drawer360.js.map